import type { ContentObjectList, NonEventContentObjectDetail } from 'models';
import { useCallback } from 'react';
import { type Network, openShareNetworkPopup } from 'common/utils';

/**
 * @deprecated
 * Dont inspire by this, needs to be rewrite
 */
export const useOnShareSocial = () =>
  useCallback((network: Network, item: ContentObjectList | NonEventContentObjectDetail) => {
    const { textContent, type } = item;
    let subject;
    if ('giving' in item) {
      const { giving } = item;
      subject = giving.name;
    }
    // TODO: this is hack
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- dynamic entity lookup by type, mirrors generateContentObjectPath
    const { id } = (item as unknown as Record<string, { id?: string } | undefined>)[type] ?? {};

    // TODO: This need fix
    const sharedContent = `${window.location.origin}/${type}s/${id}`;
    openShareNetworkPopup({ network, sharedContent, subject, text: textContent });
  }, []);
